import React from 'react';

import { AssetData } from '../../../hooks/useGetMultipleAssetUrls';
// import { QuestionAssetData } from 'src/application/ContentZone/components/Widgets/_shared/Questions/hooks/useQuestionWidgetAssetProvider';
import { SmartImage } from '@ael/shared-components-library';

type QuestionWidgetTitleImageProps = {
  assetData: AssetData | null;
};

export const QuestionWidgetTitleImage = (props: QuestionWidgetTitleImageProps) => {
  if (props.assetData === null) {
    return null;
  }
  return (
    <SmartImage
      src={props.assetData.url}
      maxImageHeight="small"
      enableZoom={true}
      loaderHeight={props.assetData.dimensions?.height}
      loaderWidth={props.assetData.dimensions?.width}
    />
  );
};
